import React from 'react';
import { X } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const UpstreamDataModal = ({ isOpen, onClose, data, isLoading, error }) => {
  const { t } = useAppContext();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-5 border-b flex justify-between items-center flex-shrink-0">
          <h2 className="text-xl font-semibold">{t('programSummary.upstreamDataTitle')}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {isLoading && (
            <div className="flex justify-center items-center p-6">
              <div className="flex flex-col items-center">
                <svg className="animate-spin h-6 w-6 text-blue-500 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span className="text-sm text-gray-600">{t('programSummary.upstreamLoading')}</span>
              </div>
            </div>
          )}

          {error && (
            <div className="text-center text-red-500 p-4 border border-red-200 rounded-md">
              {t('programSummary.upstreamError')}
            </div>
          )}

          {!isLoading && !error && data && (
            <pre className="text-xs bg-gray-50 border border-gray-200 rounded-md p-4 overflow-x-auto whitespace-pre-wrap break-words font-mono">
              {data}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpstreamDataModal;
